import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import HomePage from "./pages/Home";

const Services = React.lazy(() => import('./pages/Services'));
const StrategyAdvisory = React.lazy(() => import('./pages/StrategyAdvisory'));
const CloudSolutions = React.lazy(() => import('./pages/CloudSolutions'));
const DigitalSystemsTransformation = React.lazy(() => import('./pages/DigitalSystemsTransformation'));
const DataAnalyticsAI = React.lazy(() => import('./pages/DataAnalyticsAI'));
const CybersecurityCompliance = React.lazy(() => import('./pages/CybersecurityCompliance'));
const ChangeProcessExcellence = React.lazy(() => import('./pages/ChangeProcessExcellence'));
const Industries = React.lazy(() => import('./pages/Industries'));
const Sector = React.lazy(() => import('./pages/SectorPage'));

function App() {
  return (
    <div>
      <BrowserRouter>
        <React.Suspense fallback={<div />}> 
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/services" element={<Services />} />
            <Route path="/services/strategy-advisory" element={<StrategyAdvisory />} />
            <Route path="/services/cloud-solutions" element={<CloudSolutions />} />
            <Route path="/services/digital-systems-transformation" element={<DigitalSystemsTransformation />} />
            <Route path="/services/data-analytics-ai" element={<DataAnalyticsAI />} />
            <Route path="/services/cybersecurity-compliance" element={<CybersecurityCompliance />} />
            <Route path="/services/change-process-excellence" element={<ChangeProcessExcellence />} />
            <Route path="/industries" element={<Industries />} />
            <Route path="/industries/:slug" element={<Sector />} />
          </Routes>
        </React.Suspense>
      </BrowserRouter>
    </div>
  );
}

export default App;